import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ImageCarousel = ({
    images = [],
    imageAlt = "Carousel Image",
    className = "",
    imgClassName = "",
    children,
    autoPlay = true,
    interval = 5000,
    use1080 = false
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!autoPlay || images.length <= 1) return;

        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, interval);

        return () => clearInterval(timer);
    }, [autoPlay, interval, images.length]);

    const nextSlide = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const prevSlide = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    if (!images.length) return null;

    return (
        <div
            className={`
        relative
        w-full
        overflow-hidden
        bg-gray-900
        ${use1080 ? "aspect-[1920/1080]" : "aspect-[1920/855]"}
        group
        ${className}
      `}
        >
            {images.map((image, index) => (
                <img
                    key={index}
                    src={image}
                    alt={`${imageAlt} ${index + 1}`}
                    className={`
          absolute
          inset-0
          w-full
          h-full
          object-cover
          object-center
          transition-opacity duration-1000 ease-in-out
          ${index === currentIndex ? 'opacity-100' : 'opacity-0'}
          ${imgClassName}
        `}
                />
            ))}

            {/* Navigation Arrows */}
            {images.length > 1 && (
                <>
                    <button
                        onClick={prevSlide}
                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-2 rounded-full backdrop-blur-sm transition-all opacity-0 group-hover:opacity-100"
                    >
                        <ChevronLeft size={24} />
                    </button>
                    <button
                        onClick={nextSlide}
                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-2 rounded-full backdrop-blur-sm transition-all opacity-0 group-hover:opacity-100"
                    >
                        <ChevronRight size={24} />
                    </button>

                    {/* Dots */}
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                        {images.map((_, idx) => (
                            <button
                                key={idx}
                                onClick={() => setCurrentIndex(idx)}
                                className={`w-2 h-2 rounded-full transition-all ${idx === currentIndex
                                    ? 'bg-white w-4'
                                    : 'bg-white/50 hover:bg-white/80'
                                    }`}
                            />
                        ))}
                    </div>
                </>
            )}

            {children}


            {/* Disclaimer */}
            <div className="absolute bottom-2 right-4 z-20 pointer-events-none">
                <p className="text-[10px] md:text-xs text-white/60 drop-shadow-md">
                    Images shown for illustration purposes only.
                </p>
            </div>
        </div>
    );
};

export default ImageCarousel;
